const _ = {
  MASTER: "master",
  INDUSTRY: "industry",
  WHOLESALER: "wholesaler",
  WHOLESALER_BRANCH: "wholesaler_branch",
  POINT_OF_SALES: "point_of_sales",
  RETAILER: "retailer",
  SHOP_ASSISTANT: "shop_assistant",
  SHOP_MANAGER: "shop_manager",
  PHARMACEUTICAL: "pharmaceutical",
  BENEFITS_COMPANY: "benefits_company",
  SUPPORT: "support",
  PHARMA_INDUSTRY: "pharma_industry",
  PHARMA_BENEFIT_MANAGER: "pharma_benefit_manager",
  RETAIL_PHARMA_BENEFIT_MANAGER: "retail_pharma_benefit_manager",
  POINT_OF_SALES_BUYER: "point_of_sales_buyer",
  BENEFICIARY_CARD: "beneficiary_card",
  INDUSTRY_EMPLOYEE: "industry_employee",
  PHARMA_COMPANY: "pharma_company",
  SYSTEM_FUNCIONAL_ACESSO_ACCREDITED_ID: "system_funcional_acesso_accredited_id"
};
export {
  _ as S
};
